import api from "api";

const orders = {
    get: (params) => {
        let customParams = params.status === 'all' ? {...params, status: ''} : {...params}
        return api().get('/orders', { params: { ...customParams } });
    },

    detail: (id) => {
        return api().get(`/orders/detail/${id}`);
    },

    advanceOrderFulfillmentStatus: (orderId) => {
        return api().post(`/orders/${orderId}/fulfillment-status/advance`);
    },

    updateOrderFulfillmentStatus: (orderId, status) => {
        return api().patch(`/orders/${orderId}/fulfillment-status`, {
            status,
        });
    },

    producerRefund: (orderId) => {
        return api().post(`/orders/${orderId}/producer-refund`);
    },

    getInstallments: (orderId, paymentMethod) => {
        return api().get(`/orders/${orderId}/installments?payment_method=${paymentMethod}`);
    },
}

export default orders;